import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["copy"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import ModalNewPasswordOrganism from '~/components/_next/organisms/ModalNewPasswordOrganism.vue';
import { defineComponent } from '@nuxtjs/composition-api';
import { useCart } from '~/composables/useCart';
import useUiState from '~/composables/useUiState';
import useIsHome from '~/composables/useIsHome';
import { useWait } from '~/composables/_next/useWait';
import { useUser } from '~/composables/_next/useUser';
import { useFeatureFlagTalonOne } from '~/composables/_next/useFeatureFlagTalonOne';
import { useFeatureFlagAlgolia } from '~/composables/_next/useFeatureFlagAlgolia';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import useRightPath from '~/composables/useRightPath';
import useHtmlMeta from '~/composables/useHtmlMeta';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
import { useCustomerGroup } from '~/composables/useCustomerGroup';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useCustomizer } from '~/composables/_next/stores/useCustomizerStore';
import { useTrpc } from '~/composables/_next/useTrpc';
import { randomId } from '~/helpers/randomId';
import MenuTopbarMobileGraphql from '~/components/Molecules/MenuTopbarMobileGraphql.vue';
import FaqChatTrigger from '~/components/Layout/FaqChatTrigger.vue';
import Toaster from '~/components/Layout/Toaster.vue';
import AppHeaderGraphql from '~/components/Organisms/AppHeaderGraphql.vue';
import AppFooter from '~/components/Organisms/AppFooter.vue';
import AppReinsurance from '~/components/Organisms/AppReinsurance.vue';
import SidebarAddToCartOrganism from '~/components/_next/organisms/SidebarAddToCartOrganism.vue';
import TopBar from '~/components/Molecules/TopBar.vue';
import MenuTopbarGraphql from '~/components/Molecules/MenuTopbarGraphql.vue';
import SidebarCreateRecipeWishlistOrganism from '~/components/_next/organisms/SidebarCreateRecipeWishlistOrganism.vue';
import SidebarAddRecipeToWishlistOrganism from '~/components/_next/organisms/SidebarAddRecipeToWishlistOrganism.vue';
import Customizer from '~/components/Layout/Customizer/index.vue';
import ModalBackInStockOrganism from '~/components/_next/organisms/ModalBackInStockOrganism.vue';
import ModalAddToCartOrganism from '~/components/_next/organisms/ModalAddToCartOrganism.vue';
import { useProductWishlistStore } from '~/composables/_next/stores/useProductWishlistStore';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import ModalLocalizationChoiceOrganism from '~/components/_next/organisms/ModalLocalizationChoiceOrganism.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useToaster } from '~/composables/_next/useToaster';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  components: {
    FaqChatTrigger: FaqChatTrigger,
    Toaster: Toaster,
    AppHeaderGraphql: AppHeaderGraphql,
    MenuTopbarGraphql: MenuTopbarGraphql,
    AppFooter: AppFooter,
    AppReinsurance: AppReinsurance,
    SidebarAddToCartOrganism: SidebarAddToCartOrganism,
    TopBar: TopBar,
    SidebarCreateRecipeWishlistOrganism: SidebarCreateRecipeWishlistOrganism,
    SidebarAddRecipeToWishlistOrganism: SidebarAddRecipeToWishlistOrganism,
    Customizer: Customizer,
    ModalBackInStockOrganism: ModalBackInStockOrganism,
    ModalAddToCartOrganism: ModalAddToCartOrganism,
    MenuTopbarMobileGraphql: MenuTopbarMobileGraphql,
    ModalLocalizationChoiceOrganism: ModalLocalizationChoiceOrganism,
    ModalNewPasswordOrganism: ModalNewPasswordOrganism
  },
  setup: function setup() {
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useProductWishlistSt = useProductWishlistStore(),
      loadProductWishlist = _useProductWishlistSt.loadProductWishlist;
    var _useCustomizer = useCustomizer(),
      customizer = _useCustomizer.customizer,
      openCustomizer = _useCustomizer.openCustomizer;
    var _useWait = useWait(),
      resetWaiters = _useWait.resetWaiters;
    var context = useNuxt2App();
    var _useIsHome = useIsHome(),
      isHome = _useIsHome.isHome;
    var app = context.app,
      $sentry = context.$sentry,
      $cookies = context.$cookies,
      $flag = context.$flag,
      i18n = context.i18n,
      klaviyoToken = context.$config.klaviyoToken;
    var route = useRoute();
    var router = useRouter();
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country,
      locale = _useLocalization.locale;

    // Used to programmatically replace the :key="route.key" on the nuxt component
    // to avoid full re-renders when navigating between pages or when a the route query is changed.
    var forcedRenderKey = ref(0);
    router.afterEach(function (to) {
      if (to.name.startsWith('legacy-') || to.name.startsWith('guides___')) {
        forcedRenderKey.value = (forcedRenderKey.value + 1) % 2;
      }
    });
    var _useUiState = useUiState(),
      isLoginModalOpen = _useUiState.isLoginModalOpen,
      isCartSidebarOpen = _useUiState.isCartSidebarOpen;
    var _useIsHeaderSticky = useIsHeaderSticky(),
      isHeaderSticky = _useIsHeaderSticky.isHeaderSticky;
    var _useRightPath = useRightPath(),
      getCanonicalUrl = _useRightPath.getCanonicalUrl;
    var _useUser = useUser(),
      loadUser = _useUser.load,
      loadUserError = _useUser.error,
      isAuthenticated = _useUser.isAuthenticated,
      user = _useUser.user;
    var _useCart = useCart(),
      loadCart = _useCart.load,
      clearCart = _useCart.clear,
      hasWorkshopsInCart = _useCart.hasWorkshopsInCart,
      updateCartLocaleAndCountry = _useCart.updateCartLocaleAndCountry;
    var _useRecipesWishlists = useRecipesWishlists(),
      loadRecipesWishlists = _useRecipesWishlists.loadRecipesWishlists;
    var _useHtmlMeta = useHtmlMeta(),
      setHtmlLocale = _useHtmlMeta.setHtmlLocale;
    resetWaiters();
    var _useToaster = useToaster(),
      showToast = _useToaster.show;
    var _useCustomerGroup = useCustomerGroup(),
      setCustomerGroup = _useCustomerGroup.setCustomerGroup,
      removeCustomerGroup = _useCustomerGroup.removeCustomerGroup;
    var modalBackInStock = ref(null);
    var modalStoreSwitcher = ref(null);
    var modalAddToCart = ref(null);
    var contentfulResponse = useState('layout-contentfulResponse', function () {
      return null;
    });
    var klaviyoUrl = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=".concat(klaviyoToken);
    var isGoToReferral = computed(function () {
      return route.query.referral === 'true';
    });
    var isCopy = computed(function () {
      var _route$query, _route$query2;
      return !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.copy) && ((_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.copy) !== '';
    });
    var queryTokenResetPassword = computed(function () {
      return route.query['password-token'];
    });
    setHtmlLocale();
    useLazyAsyncData('layouts-default', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.contentful.getDefaultLayout.query({
              locale: locale
            });
          case 2:
            contentfulResponse.value = _context.sent;
            return _context.abrupt("return", true);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var mounted = ref(false);
    watch([route, mounted], function () {
      var _route$query3;
      if (!mounted.value) return;
      if ((route === null || route === void 0 ? void 0 : route.hash) === '#customizer') openCustomizer();
      if ((route === null || route === void 0 ? void 0 : route.hash) === '#connection') navigateToOrLogin({
        nextRoutePath: {
          name: 'my-account'
        },
        previousRoutePath: route.path
      });
      if (route !== null && route !== void 0 && (_route$query3 = route.query) !== null && _route$query3 !== void 0 && _route$query3.bp_e) {
        router.push(app.localePath({
          name: 'signup',
          query: {
            bp_e: route.query.bp_e
          }
        }));
      }
      if (isCopy.value) {
        navigator.clipboard.writeText(String(route.query.copy)).then(function () {
          showToast({
            title: i18n.t('layouts.default.toast.code-copied'),
            iconName: 'checkmark'
          }, 2000);
          var _route$query4 = route.query,
            copy = _route$query4.copy,
            queryWithoutCopy = _objectWithoutProperties(_route$query4, _excluded);
          router.replace({
            query: queryWithoutCopy
          }).catch(function (err) {
            return console.warn(err);
          });
        }).catch(function (err) {
          showToast({
            title: i18n.t('layouts.default.toast.code-not-copied'),
            iconName: 'warning'
          }, 2000);
          console.warn(err);
        });
      }
    }, {
      immediate: true
    });
    var iAdvizeEnabled = ref(false);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            iAdvizeEnabled.value = $flag.get('iAdvizeEnabled');
            mounted.value = true;
            _context2.next = 4;
            return loadUser();
          case 4:
            if (user.value) {
              sendSentryContext(user.value);
            }
            sendTgglContext(user.value);
            _context2.next = 8;
            return loadCart(true);
          case 8:
            if (!hasWorkshopsInCart.value) {
              _context2.next = 11;
              break;
            }
            _context2.next = 11;
            return clearCart();
          case 11:
            _context2.next = 13;
            return updateCartLocaleAndCountry({
              locale: locale,
              country: country
            });
          case 13:
            if (!isGoToReferral.value) {
              _context2.next = 16;
              break;
            }
            _context2.next = 16;
            return navigateToOrLogin({
              nextRoutePath: {
                name: 'my-account-referral'
              }
            });
          case 16:
            if (window && typeof window.unlockABTasty === 'function') {
              window.unlockABTasty();
            }
            sendDYIdentify();
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    watch(isAuthenticated, function (newValue, oldValue) {
      if (newValue === oldValue) return;
      sendDYIdentify();
      if (!newValue) {
        removeCustomerGroup();
        return;
      } else {
        setCustomerGroup(user.value.customerGroup);
      }
      loadRecipesWishlists(true);
      loadProductWishlist(true);
    }, {
      immediate: false
    });
    watch(loadUserError, function () {
      Object.keys(loadUserError.value).forEach(function (errorKey) {
        loadUserError.value[errorKey] && console.error("failed while load User ".concat(errorKey, ": ").concat(loadUserError.value[errorKey]));
      });
    });
    var errored = computed(function () {
      var _app$context;
      return (_app$context = app.context) === null || _app$context === void 0 ? void 0 : _app$context._errored;
    });
    var topbarData = computed(function () {
      var _contentfulResponse$v, _contentfulResponse$v2, _contentfulResponse$v3, _contentfulResponse$v4, _contentfulResponse$v5;
      var topbar = (_contentfulResponse$v = contentfulResponse.value) === null || _contentfulResponse$v === void 0 ? void 0 : (_contentfulResponse$v2 = _contentfulResponse$v.data) === null || _contentfulResponse$v2 === void 0 ? void 0 : (_contentfulResponse$v3 = _contentfulResponse$v2.configGlobalCollection) === null || _contentfulResponse$v3 === void 0 ? void 0 : (_contentfulResponse$v4 = _contentfulResponse$v3.items[0]) === null || _contentfulResponse$v4 === void 0 ? void 0 : (_contentfulResponse$v5 = _contentfulResponse$v4.header) === null || _contentfulResponse$v5 === void 0 ? void 0 : _contentfulResponse$v5.defaultPageHeader;
      return topbar;
    });
    var menuData = computed(function () {
      var _contentfulResponse$v6, _contentfulResponse$v7, _contentfulResponse$v8, _contentfulResponse$v9;
      var header = (_contentfulResponse$v6 = (_contentfulResponse$v7 = contentfulResponse.value) === null || _contentfulResponse$v7 === void 0 ? void 0 : (_contentfulResponse$v8 = _contentfulResponse$v7.data) === null || _contentfulResponse$v8 === void 0 ? void 0 : (_contentfulResponse$v9 = _contentfulResponse$v8.headerNavigationGlobalCollection) === null || _contentfulResponse$v9 === void 0 ? void 0 : _contentfulResponse$v9.items[0]) !== null && _contentfulResponse$v6 !== void 0 ? _contentfulResponse$v6 : {};
      return header;
    });
    var footerData = computed(function () {
      var _contentfulResponse$v0, _contentfulResponse$v1, _contentfulResponse$v10, _contentfulResponse$v11;
      var footer = (_contentfulResponse$v0 = (_contentfulResponse$v1 = contentfulResponse.value) === null || _contentfulResponse$v1 === void 0 ? void 0 : (_contentfulResponse$v10 = _contentfulResponse$v1.data) === null || _contentfulResponse$v10 === void 0 ? void 0 : (_contentfulResponse$v11 = _contentfulResponse$v10.layoutFooterCollection) === null || _contentfulResponse$v11 === void 0 ? void 0 : _contentfulResponse$v11.items[0]) !== null && _contentfulResponse$v0 !== void 0 ? _contentfulResponse$v0 : {};
      return footer;
    });
    var reinsuranceData = computed(function () {
      var _contentfulResponse$v12, _contentfulResponse$v13, _contentfulResponse$v14, _contentfulResponse$v15, _contentfulResponse$v16, _contentfulResponse$v17;
      var reinsurance = (_contentfulResponse$v12 = (_contentfulResponse$v13 = contentfulResponse.value) === null || _contentfulResponse$v13 === void 0 ? void 0 : (_contentfulResponse$v14 = _contentfulResponse$v13.data) === null || _contentfulResponse$v14 === void 0 ? void 0 : (_contentfulResponse$v15 = _contentfulResponse$v14.reinsuranceCollection) === null || _contentfulResponse$v15 === void 0 ? void 0 : (_contentfulResponse$v16 = _contentfulResponse$v15.items[0]) === null || _contentfulResponse$v16 === void 0 ? void 0 : (_contentfulResponse$v17 = _contentfulResponse$v16.itemsCollection) === null || _contentfulResponse$v17 === void 0 ? void 0 : _contentfulResponse$v17.items) !== null && _contentfulResponse$v12 !== void 0 ? _contentfulResponse$v12 : [];
      return reinsurance;
    });

    /**
     * Sends context data to sentry.
     */
    function sendSentryContext(user) {
      $sentry === null || $sentry === void 0 ? void 0 : $sentry.setUser({
        id: user === null || user === void 0 ? void 0 : user.id,
        email: user === null || user === void 0 ? void 0 : user.email,
        externalId: user === null || user === void 0 ? void 0 : user.externalId
      });
    }
    var _useFeatureFlagTalonO = useFeatureFlagTalonOne(),
      setIsTalonOneEnabled = _useFeatureFlagTalonO.setIsTalonOneEnabled;
    var _useFeatureFlagAlgoli = useFeatureFlagAlgolia(),
      setIsAlgoliaEnabled = _useFeatureFlagAlgoli.setIsAlgoliaEnabled;

    /**
     * Sends context data to Tggl.
     */
    function sendTgglContext(_x) {
      return _sendTgglContext.apply(this, arguments);
    }
    /**
     * Trigger a Dynamic Yield Identify event only if the user is authenticated.
     * Sends user ID using the 'CommercetoolsID' format.
     */
    function _sendTgglContext() {
      _sendTgglContext = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(user) {
        var _user$id, _user$customerGroup;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return $flag.setContext({
                environment: process.env.CURRENT_ENV,
                userId: (_user$id = user === null || user === void 0 ? void 0 : user.id) !== null && _user$id !== void 0 ? _user$id : $cookies.get('az_uuid'),
                email: user === null || user === void 0 ? void 0 : user.email,
                externalId: user === null || user === void 0 ? void 0 : user.externalId,
                customerGroup: user === null || user === void 0 ? void 0 : (_user$customerGroup = user.customerGroup) === null || _user$customerGroup === void 0 ? void 0 : _user$customerGroup.key,
                locale: locale.toLowerCase(),
                country: country,
                sessionId: randomId()
              });
            case 2:
              setIsTalonOneEnabled($flag.get('enableTalonOne', false));
              setIsAlgoliaEnabled($flag.get('algoliaSearchAndCategories', false));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _sendTgglContext.apply(this, arguments);
    }
    function sendDYIdentify() {
      if (isAuthenticated.value) {
        trackDynamicYieldEvent({
          name: 'Identify',
          properties: {
            dyType: 'identify-v1',
            cuid: user.value.id,
            cuidType: 'CommercetoolsID'
          }
        });
      }
    }
    var _useLegacySeoMeta = useLegacySeoMeta(),
      getMeta = _useLegacySeoMeta.getMeta,
      jsonld = _useLegacySeoMeta.jsonld;
    var _useWorkshop = useWorkshop(),
      restoreSavedCart = _useWorkshop.restoreSavedCart;
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            restoreSavedCart();
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    useHead(function () {
      var _meta$link;
      var meta = getMeta();
      var link = (_meta$link = meta.link) !== null && _meta$link !== void 0 ? _meta$link : [];
      if (!errored.value && !link.find(function (link) {
        return link.rel === 'canonical';
      })) {
        link.push({
          rel: 'canonical',
          href: getCanonicalUrl()
        });
      }
      var script = [];
      if (jsonld.value) script.push({
        type: 'application/ld+json',
        innerHTML: JSON.stringify(jsonld.value)
      });
      return _objectSpread(_objectSpread({
        title: 'Aroma-Zone'
      }, meta), {}, {
        link: link,
        script: script
      });
    });
    return {
      customizer: customizer,
      getMeta: getMeta,
      jsonld: jsonld,
      route: route,
      topbarData: topbarData,
      menuData: menuData,
      footerData: footerData,
      reinsuranceData: reinsuranceData,
      getCanonicalUrl: getCanonicalUrl,
      errored: errored,
      klaviyoUrl: klaviyoUrl,
      isLoginModalOpen: isLoginModalOpen,
      isCartSidebarOpen: isCartSidebarOpen,
      forcedRenderKey: forcedRenderKey,
      isHeaderSticky: isHeaderSticky,
      iAdvizeEnabled: iAdvizeEnabled,
      mounted: mounted,
      isHome: isHome,
      modalStoreSwitcher: modalStoreSwitcher,
      modalBackInStock: modalBackInStock,
      modalAddToCart: modalAddToCart,
      queryTokenResetPassword: queryTokenResetPassword,
      i18n: i18n
    };
  }
});